import React, { useState, useEffect } from 'react';
import {
  Button,
  TextField,
  Tooltip,
  Container,
  CircularProgress,
  Typography,
  InputAdornment,
  Box,
  AppBar, Chip,
  Toolbar,
  Table,
  Modal,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import { Delete as DeleteIcon, Edit as EditIcon, Visibility as VisibilityIcon } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import MuiAlert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Homework = () => {
  const navigate = useNavigate();

const [selectedFiles, setSelectedFiles] = useState([]);
const [uploading, setUploading] = useState(false);
const [showDeleteFileConfirm, setShowDeleteFileConfirm] = useState(false);
const [fileToDelete, setFileToDelete] = useState(null);


  // State for dropdowns
  const [classId, setClassId] = useState('');
  const [sectionId, setSectionId] = useState('');

  // State for dropdown data
 const [classData, setClassData] = useState([]);
const [sectionData, setSectionData] = useState([]);
const [homeworks, setHomeworks] = useState([]);
  const [filteredData, setFilteredData] = useState(homeworks);
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedHomework, setSelectedHomework] = useState(null);
  const [canDelete, setCanDelete] = useState(true);
  const [canEdit, setCanEdit] = useState(true);
  const [canAdd, setCanAdd] = useState(true);


  const fetchClassData = async () => {
  try {
    setLoadingBarProgress(30);
    const token = sessionStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/CreateClass/GetClassName`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({}),
    });

    if (response.ok) {
      const responseData = await response.json();
      setClassData(Array.isArray(responseData) ? responseData : []);
      setLoadingBarProgress(100);
    } else {
      setSnackbarMessage('Failed to fetch class data');
      setOpenSnackbar(true);
      setSnackbarSeverity('error');
      setClassData([]);
      setLoadingBarProgress(0);
    }
  } catch (error) {
    setSnackbarMessage('An error occurred. Please try again later.');
    setOpenSnackbar(true);
    setSnackbarSeverity('error');
  }
};

// Fetch Section Data
const fetchSectionData = async (selectedClassId) => {
  try {
    setLoadingBarProgress(30);
    const token = sessionStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/AssignmentCreate/ddlSection_clsId`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({ classId: selectedClassId }),
    });

    if (response.ok) {
      const responseData = await response.json();
      setSectionData(Array.isArray(responseData) ? responseData : []);
      setLoadingBarProgress(100);
    } else {
      setSnackbarMessage('Failed to fetch section data');
      setOpenSnackbar(true);
      setSnackbarSeverity('error');
      setSectionData([]);
      setLoadingBarProgress(0);
    }
  } catch (error) {
    setSnackbarMessage('An error occurred. Please try again later.');
    setOpenSnackbar(true);
    setSnackbarSeverity('error');
  }
};

// Fetch Homework List
const fetchHomeworkList = async (selectedClassId, selectedSectionId) => {
  try {
    setLoadingBarProgress(30);
    const token = sessionStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/Homework/ListByClass`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({ classId: selectedClassId, sectionId: selectedSectionId }),
    });

    if (response.ok) {
      const responseData = await response.json();
      setHomeworks(Array.isArray(responseData.homework) ? responseData.homework : []);
      setFilteredData(Array.isArray(responseData.homework) ? responseData.homework : []);
      setLoadingBarProgress(100);
    } else {
      setSnackbarMessage('Failed to fetch homework list');
      setOpenSnackbar(true);
      setSnackbarSeverity('error');
      setHomeworks([]);
      setFilteredData([]);
      setLoadingBarProgress(0);
    }
  } catch (error) {
    setSnackbarMessage('An error occurred. Please try again later.');
    setOpenSnackbar(true);
    setSnackbarSeverity('error');
    setHomeworks([]);
    setFilteredData([]);
    setLoadingBarProgress(0);
  }
};


// Fetch Class Data on Component Mount
useEffect(() => {
  fetchClassData();
}, []);

// Fetch Section Data when Class is Selected
useEffect(() => {
  if (classId) {
    fetchSectionData(classId);
    setSectionId('');
  }
}, [classId]);

// Fetch Homework List when Section is Selected
useEffect(() => {
  if (sectionId && classId) {
    fetchHomeworkList(classId, sectionId);
  }
}, [sectionId, classId]);

  // Search and filter logic
 // Search and filter logic
React.useEffect(() => {
  if (searchTerm) {
    setFilteredData(
      homeworks.filter((hw) =>
        hw.caption.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  } else {
    setFilteredData(homeworks);
  }
  setPage(1);
}, [searchTerm, homeworks]);


  // Pagination Logic
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  // Modal Handlers
  const handleView = (homework) => {
    setSelectedHomework(homework);
    setShowViewModal(true);
  };

  const handleDeleteShow = (homework) => {
    setSelectedHomework(homework);
    setShowDeleteModal(true);
  };

  const handleClose = () => {
    setShowViewModal(false);
    setShowDeleteModal(false);
  };

  const handleDelete = async () => {
  try {
    setLoadingBarProgress(30);
    const token = sessionStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/Homework/${selectedHomework.homeworkId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (response.ok) {
      setHomeworks(homeworks.filter((hw) => hw.homeworkId !== selectedHomework.homeworkId));
      setFilteredData(filteredData.filter((hw) => hw.homeworkId !== selectedHomework.homeworkId));
      setSnackbarMessage('Homework deleted successfully!');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
    } else {
      setSnackbarMessage('Failed to delete homework');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  } catch (error) {
    setSnackbarMessage('An error occurred. Please try again later.');
    setSnackbarSeverity('error');
    setOpenSnackbar(true);
  } finally {
    setShowDeleteModal(false);
    setLoadingBarProgress(100);
  }
};
 

  const handleEdit = (id) => {
    navigate(`/edit-homework/${id}`);
  };

  const handleAdd = () => {
    navigate('/add-homework');
  };

  // Pagination Handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleFileUpload = async () => {
  if (!selectedFiles.length || !selectedHomework) return;

  setUploading(true);
  const formData = new FormData();
  selectedFiles.forEach((file) => formData.append('files', file));

  try {
    const token = sessionStorage.getItem('token');
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Homework/${selectedHomework.homeworkId}/AddFiles`,
      {
        method: 'POST',
        headers: {
          Authorization: token,
        },
        body: formData,
      }
    );

    if (response.ok) {
      setSnackbarMessage('Files uploaded successfully!');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      // Refresh homework data
      fetchHomeworkList(classId, sectionId);
    } else {
      setSnackbarMessage('Failed to upload files');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  } catch (error) {
    setSnackbarMessage('An error occurred. Please try again later.');
    setSnackbarSeverity('error');
    setOpenSnackbar(true);
  } finally {
    setUploading(false);
    setSelectedFiles([]);
  }
};

const handleDeleteFile = async (fileId) => {
  if (!selectedHomework) return;

  try {
    const token = sessionStorage.getItem('token');
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Homework/File/${fileId}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );

    if (response.ok) {
      setSnackbarMessage('File deleted successfully!');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      // Refresh homework data
      fetchHomeworkList(classId, sectionId);
    } else {
      setSnackbarMessage('Failed to delete file');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  } catch (error) {
    setSnackbarMessage('An error occurred. Please try again later.');
    setSnackbarSeverity('error');
    setOpenSnackbar(true);
  }
};


  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          backgroundColor: '#0B1F3D',
          borderRadius: '8px 8px 0 0',
          mb: 0
        }}
      >
        <Toolbar sx={{ py: 1.5 }}>
          <Typography variant="h4" component="div" sx={{ fontWeight: 600, letterSpacing: '0.5px' }}>
            Homework
          </Typography>
        </Toolbar>
      </AppBar>

      <Paper
        elevation={3}
        sx={{
          padding: 3,
          width: '100%',
          margin: 'auto',
          borderRadius: '0 0 8px 8px',
          backgroundColor: '#fafafa'
        }}
      >
        <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />

        {/* Search and Add Homework Button */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 3,
            gap: 2,
            flexWrap: { xs: 'wrap', sm: 'nowrap' }
          }}
        >
        <TextField
  variant="outlined"
  placeholder="Search homework..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  sx={{
    width: { xs: '100%', sm: '350px' },
    backgroundColor: '#ffffff',
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      '&:hover fieldset': {
        borderColor: '#0B1F3D',
      },
    },
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <SearchIcon sx={{ color: '#666' }} />
      </InputAdornment>
    ),
  }}
/>

          <Tooltip title={!canAdd ? 'You are not authorized to add' : ''} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleAdd}
                disabled={!canAdd}
                color='primary'
                sx={{
                  width: { xs: '100%', sm: '160px' },
                  height: '56px',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  letterSpacing: '0.5px',
                }}
              >
                ADD HOMEWORK
              </Button>
            </span>
          </Tooltip>
        </Box>

        {/* Dropdowns for Class and Section */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
            gap: 2.5,
            mb: 3,
            p: 2,
            backgroundColor: '#ffffff',
            borderRadius: 2,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}
        >
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="class">Class</InputLabel>
            <Select
              id="class"
              value={classId}
              label="Class"
              onChange={(e) => setClassId(e.target.value)}
              sx={{ backgroundColor: '#fff' }}
            >
              {classData.map((classItem) => (
                <MenuItem key={classItem.classId} value={classItem.classId}>
                  {classItem.className}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="section">Section</InputLabel>
            <Select
              id="section"
              value={sectionId}
              label="Section"
              onChange={(e) => setSectionId(e.target.value)}
              disabled={!classId}
              sx={{ backgroundColor: '#fff' }}
            >
              {sectionData.map((sectionItem) => (
                <MenuItem key={sectionItem.sectionId} value={sectionItem.sectionId}>
                  {sectionItem.sectionName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Homework Table */}
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 2,
            boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
            overflow: 'hidden'
          }}
        >
          <Table
            sx={{
              minWidth: 650,
              '& .MuiTableCell-root': {
                borderRight: '1px solid #e0e0e0',
                fontSize: '0.95rem',
                padding: '14px 16px',
              },
              '& .MuiTableHead-root .MuiTableCell-root': {
                fontWeight: 700,
                backgroundColor: '#f8f9fa',
                color: '#2c3e50',
                borderBottom: '2px solid #dee2e6',
                textTransform: 'uppercase',
                fontSize: '0.85rem',
                letterSpacing: '0.5px',
              },
              '& .MuiTableBody-root .MuiTableRow-root': {
                '&:hover': {
                  backgroundColor: '#f5f7fa',
                  transition: 'background-color 0.2s ease',
                },
                '&:last-child td': {
                  borderBottom: 'none',
                }
              }
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Homework Date</TableCell>
                <TableCell>Submission Date</TableCell>
                <TableCell sx={{ textAlign: 'center', borderRight: 'none !important' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loadingBarProgress > 0 && loadingBarProgress < 100 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 6, borderRight: 'none !important' }}>
                    <CircularProgress size={40} thickness={4} />
                    <Typography variant="body2" sx={{ mt: 2, color: '#666' }}>
                      Loading homeworks...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((homework, index) => (
                   <TableRow
      key={homework.homeworkId}
      sx={{
        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
      }}
    >
     <TableCell>
  <Typography variant="body2" sx={{ fontWeight: 500 }}>
    {(page - 1) * rowsPerPage + index + 1}
  </Typography>
</TableCell>

      <TableCell>
        <Typography variant="body2" sx={{ fontWeight: 500, color: '#2c3e50' }}>
          {homework.caption}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" sx={{ color: '#495057' }}>
          {new Date(homework.homeworkDate).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" sx={{ color: '#495057' }}>
          {new Date(homework.dueDate).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell sx={{ textAlign: 'center', borderRight: 'none !important' }}>
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Tooltip title={canEdit ? '' : 'You are not authorized to edit'} arrow>
            <span>
              <Button
                variant="contained"
                size="small"
                color='warning'
                onClick={() => handleEdit(homework.homeworkId)}
                disabled={!canEdit}
                startIcon={<EditIcon sx={{ fontSize: '1rem' }} />}
                sx={{
                  minWidth: '85px',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  textTransform: 'none',
                  padding: '6px 12px',
                }}
              >
                Edit
              </Button>
            </span>
          </Tooltip>
          <Tooltip title={!canDelete ? 'You are not authorized to delete' : ''} arrow>
            <span>
              <Button
                variant="contained"
                size="small"
                color='error'
                onClick={() => handleDeleteShow(homework)}
                disabled={!canDelete}
                startIcon={<DeleteIcon sx={{ fontSize: '1rem' }} />}
                sx={{
                  minWidth: '95px',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  textTransform: 'none',
                  padding: '6px 12px',
                }}
              >
                Delete
              </Button>
            </span>
          </Tooltip>
          <Tooltip title="View Homework" arrow>
            <span>
              <Button
                variant="contained"
                size="small"
                color='info'
                onClick={() => handleView(homework)}
                startIcon={<VisibilityIcon sx={{ fontSize: '1rem' }} />}
                sx={{
                  minWidth: '85px',
                  fontSize: '0.8rem',
                  fontWeight: 600,
                  textTransform: 'none',
                  padding: '6px 12px',
                }}
              >
                View
              </Button>
            </span>
          </Tooltip>
        </Box>
      </TableCell>
    </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 6, borderRight: 'none !important' }}>
                    <Typography variant="body1" sx={{ color: '#999', fontWeight: 500 }}>
                      No Homeworks Found
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#bbb', mt: 1 }}>
                      Please select filters to view homeworks
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* View Homework Modal */}
<Modal open={showViewModal} onClose={handleClose}>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: { xs: '95%', sm: 600 }, // Increased width
      maxHeight: '80vh', // Increased height
      bgcolor: 'background.paper',
      borderRadius: 3,
      boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
      overflow:'hidden',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Box
      sx={{
        backgroundColor: '#0B1F40',
        padding: '16px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
          position: 'relative', // 👈 add this
      }}
    >
        <IconButton
  onClick={handleClose}
  sx={{
    position: 'absolute',
    top: 8,
    right: 8,
    color: '#fff',
  }}
>
  <CloseIcon />
</IconButton>

      <Typography
        variant="h6"
        sx={{
          color: '#fff',
          fontWeight: 600,
          fontSize: '1.1rem'
        }}
      >
        View Homework
      </Typography>
    </Box>
    <Box sx={{ padding: '24px 20px', overflowX:'hidden',  overflowY: 'auto',}}>
      <Typography
        sx={{
          mb: 3,
          fontSize: '1rem',
          color: '#495057',
          lineHeight: 1.6
        }}
      >
        Homework:<br></br> <strong>{selectedHomework?.caption}</strong>
      </Typography>

   <Box sx={{ mb: 2 }}>
  <input
    type="file"
    multiple
    onChange={(e) => setSelectedFiles([...selectedFiles, ...Array.from(e.target.files)])}
    style={{ display: 'none' }}
    id="file-upload"
  />
  <label htmlFor="file-upload">
    <Button
      variant="outlined"
      component="span"
      startIcon={<CloudUploadIcon />}
      disabled={uploading}
      sx={{ fontWeight: 600, textTransform: 'none', mb: 1 }}
    >
      {uploading ? 'Uploading...' : 'Add Files'}
    </Button>
  </label>
  {/* Show selected files as chips */}
  {selectedFiles.length > 0 && (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
      {selectedFiles.map((file, index) => (
        <Chip
          key={index}
          label={file.name}
          onDelete={() => {
            const newFiles = [...selectedFiles];
            newFiles.splice(index, 1);
            setSelectedFiles(newFiles);
          }}
          sx={{ maxWidth: '200px' }}
        />
      ))}
    </Box>
  )}
</Box>


   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 3, maxHeight: '300px', overflow: 'auto' }}>
  {selectedHomework?.files?.length > 0 ? (
    selectedHomework.files.map((file) => (
      <Box
        key={file.fileId}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 1.5,
          backgroundColor: '#f8f9fa',
          borderRadius: 1,
        }}
      >
        <Button
          variant="text"
          onClick={() =>
            window.open(
              `${process.env.REACT_APP_DOCUMENT_URL}${file.filePath}`,
              '_blank'
            )
          }
          sx={{ fontWeight: 600, textTransform: 'none', justifyContent: 'flex-start' }}
        >
          {file.originalFileName}
        </Button>
        <IconButton
          onClick={() => {
            setFileToDelete(file);
            setShowDeleteFileConfirm(true);
          }}
          color="error"
          sx={{ p: 0.5 }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Box>
    ))
  ) : (
    <Typography variant="body2" sx={{ color: '#666' }}>
      No files attached.
    </Typography>
  )}
</Box>



     
    </Box>
     <Box sx={{ padding: '24px 20px', display: 'flex', justifyContent: 'flex-end' }}>
       <Button
  onClick={handleFileUpload}
  variant="contained"
  color="primary"
  disabled={!selectedFiles.length || uploading}
  sx={{
    fontWeight: 600,
    textTransform: 'none',
    px: 3,
    mr: 1,
  }}
>
  Save Changes
</Button>
      </Box>
  </Box>
</Modal>


<Modal open={showDeleteFileConfirm} onClose={() => setShowDeleteFileConfirm(false)}>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: { xs: '90%', sm: 400 },
      bgcolor: 'background.paper',
      borderRadius: 3,
      boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
      p: 3,
      textAlign: 'center',
    }}
  >
    <Typography variant="h6" sx={{ mb: 2 }}>
      Confirm Delete
    </Typography>
    <Typography sx={{ mb: 3 }}>
      Are you sure you want to delete <strong>{fileToDelete?.originalFileName}</strong>?
    </Typography>
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
      <Button
        variant="outlined"
        onClick={() => setShowDeleteFileConfirm(false)}
        sx={{ fontWeight: 600, textTransform: 'none' }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={async () => {
          await handleDeleteFile(fileToDelete.fileId);
          setShowDeleteFileConfirm(false);
        }}
        sx={{ fontWeight: 600, textTransform: 'none' }}
      >
        Delete
      </Button>
    </Box>
  </Box>
</Modal>

        {/* Delete Confirmation Modal */}
        <Modal open={showDeleteModal} onClose={handleClose}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: { xs: '90%', sm: 450 },
              bgcolor: 'background.paper',
              borderRadius: 3,
              boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                backgroundColor: '#0B1F40',
                padding: '16px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '1.1rem'
                }}
              >
                Delete Confirmation
              </Typography>
              <Typography sx={{ color: '#ffd700', fontSize: '1.3rem' }}>⚠️</Typography>
            </Box>
            <Box sx={{ padding: '24px 20px' }}>
              <Typography
                sx={{
                  mb: 3,
                  fontSize: '1rem',
                  color: '#495057',
                  lineHeight: 1.6
                }}
              >
                Are you sure you want to delete: <br></br><strong>{selectedHomework?.caption}</strong> ?
                </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#dc3545',
                  mb: 3,
                  fontSize: '0.9rem'
                }}
              >
                This action cannot be undone.
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5 }}>
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  sx={{
                    borderColor: '#6c757d',
                    color: '#6c757d',
                    fontWeight: 600,
                    textTransform: 'none',
                    px: 3,
                    '&:hover': {
                      borderColor: '#5a6268',
                      backgroundColor: '#f8f9fa',
                    }
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleDelete}
                  sx={{
                    backgroundColor: '#dc3545',
                    fontWeight: 600,
                    textTransform: 'none',
                    px: 3,
                    '&:hover': {
                      backgroundColor: '#c82333',
                    }
                  }}
                >
                  Yes, Delete
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>

        {/* Pagination */}
        {filteredData.length > 0 && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mt: 3,
              p: 2,
              backgroundColor: '#ffffff',
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              flexWrap: { xs: 'wrap', sm: 'nowrap' },
              gap: 2
            }}
          >
            <TextField
              select
              label="Rows per page"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              sx={{
                width: { xs: '100%', sm: 150 },
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                }
              }}
              SelectProps={{ native: true }}
            >
              {[5, 10, 25, 50].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 500,
                  color: '#495057'
                }}
              >
                Page {page} of {Math.ceil(filteredData.length / rowsPerPage)}
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  variant="outlined"
                  onClick={() => handleChangePage(null, page - 1)}
                  disabled={page === 1}
                  sx={{
                    minWidth: '80px',
                    fontWeight: 600,
                    borderRadius: 2,
                    '&:hover': {
                      backgroundColor: '#f8f9fa',
                    }
                  }}
                >
                  Prev
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => handleChangePage(null, page + 1)}
                  disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
                  sx={{
                    minWidth: '80px',
                    fontWeight: 600,
                    borderRadius: 2,
                    '&:hover': {
                      backgroundColor: '#f8f9fa',
                    }
                  }}
                >
                  Next
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </Paper>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{
            width: '100%',
            borderRadius: 2,
            fontWeight: 500
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Homework;
